import { ProgressStepState } from '@lifebit-ai/lds'

import { ImportActivityStageState } from './enums'
import type { ImportActivityTimelineEntry } from './types'

export const mapImportActivityTimelineStateToProgressStepState = (
  state: ImportActivityStageState
): ProgressStepState => {
  switch (state) {
    case ImportActivityStageState.NotStarted:
    case ImportActivityStageState.Waiting:
      return ProgressStepState.Pending
    case ImportActivityStageState.Active:
      return ProgressStepState.Active
    case ImportActivityStageState.Complete:
      return ProgressStepState.Completed
    case ImportActivityStageState.Skipped:
      return ProgressStepState.Completed
    case ImportActivityStageState.Failed:
      return ProgressStepState.Failed
    default:
      return ProgressStepState.Pending
  }
}

const isImportActivityStageFinished = (state: ImportActivityStageState): boolean =>
  state === ImportActivityStageState.Complete || state === ImportActivityStageState.Skipped

export const getImportActivityStageTimestampIso = (
  timelineEntry: ImportActivityTimelineEntry | undefined,
  legacyCompletedAt?: string
): string | undefined => {
  if (timelineEntry === undefined) {
    return legacyCompletedAt
  }

  if (timelineEntry.state === ImportActivityStageState.Active) {
    return timelineEntry.startedAt
  }

  if (isImportActivityStageFinished(timelineEntry.state) || timelineEntry.state === ImportActivityStageState.Failed) {
    return (
      timelineEntry.completedAt ?? (isImportActivityStageFinished(timelineEntry.state) ? legacyCompletedAt : undefined)
    )
  }

  return undefined
}
